import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ExtraCampaignsServiceProvider } from '../../api/extra-campaigns'

const ExtraCampaignsService = ExtraCampaignsServiceProvider()
const name = 'alternativeCampaignAddEmail'

export default (id, alternativeCampaignId) => {
  const data = { id }
  if (alternativeCampaignId) {
    data.alternativeCampaignId = alternativeCampaignId
  }
  return asyncAction(
    name,
    ExtraCampaignsService.alternativeCampaignAddEmail,
    data
  )
}

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/extra-campaign/alternativeCampaignAddEmail.js